import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { actionTypes } from 'constants/global/action.type';
import Framework7 from 'framework7/lite-bundle';
import Framework7React from 'framework7-react';
Framework7.use(Framework7React);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const loadLocalCustomMessages = async () => {
  try {
    const res = await fetch(`/customization/customMessages.json?${(window as any)?.dynamicVersion}`);
    if (!res.ok) {
      throw new Error(`customMessages.json responded ${res.status}`);
    }
    const data = await res.json();
    store.dispatch({ type: actionTypes.LOCAL_CUSTOM_MESSAGES_JSON_DATA, localCustomMessagesJsonData: data });
  } catch (err) {
    console.error("customMessages.json failed to load", err);
  }
};

// the index.html loader stays on screen until the text data is in the store
loadLocalCustomMessages().finally(() => {
  // remove loader of index.html page
  document.getElementsByClassName("index-bg-white")[0]?.remove();

  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
